import * as React from 'react';
import { Selectors } from '@grandvisionhq/auth';
import { useSelector, useIntl } from '@grandvisionhq/state';
import { LoadingData } from '../LoadingData.js';
import { usePersonalDetails } from '../../hooks/use-personal-details.js';
import { usePreferredStore } from '../../hooks/use-preferred-store.js';
import { ErrorAlert } from '../ErrorAlert.js';
import PreferredStore from './PreferredStore.js';

const PreferredStoreContainer = ()=>{
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [showUpdateError, setShowUpdateError] = React.useState(false);
    const userId = useSelector(Selectors.getUserId);
    const intl = useIntl();
    const { isUpdating , updatePersonalDetails  } = usePersonalDetails({
        onCompleted: ()=>setShowUpdateError(false)
        ,
        onError: ()=>setShowUpdateError(true)
    });
    const { data: preferredStoreData , loading: storeLoading , error: storeError , refetch ,  } = usePreferredStore();
    const onOpenModal = React.useCallback(()=>{
        setIsModalOpen(true);
    }, []);
    const onCloseModal = React.useCallback(()=>{
        setIsModalOpen(false);
    }, []);
    const handleChangePreferredStore = React.useCallback((globalStoreId)=>{
        if (!userId) {
            return;
        }
        updatePersonalDetails({
            preferredGlobalStoreId: globalStoreId
        }, userId);
    }, [
        updatePersonalDetails,
        userId
    ]);
    const onStoreSelect = React.useCallback((store)=>{
        if (!store) {
            return;
        }
        onCloseModal();
        handleChangePreferredStore(store.globalStoreId);
        refetch();
    }, [
        handleChangePreferredStore,
        onCloseModal,
        refetch
    ]);
    if (storeLoading || isUpdating) {
        return /*#__PURE__*/ React.createElement(LoadingData, null);
    }
    if (storeError) {
        return /*#__PURE__*/ React.createElement(ErrorAlert, {
            message: intl.getFormattedLabel('account.preferredStore.errors.network.general', {
                parseLink: true
            })
        });
    }
    const errorElement = showUpdateError ? /*#__PURE__*/ React.createElement(ErrorAlert, {
        message: intl.getFormattedLabel('account.preferredStore.errors.update.general', {
            parseLink: true
        })
    }) : null;
    const preferredStoreLabels = {
        noStoreSelected: intl.getLabel('account.profile.preferredStore.noStoreSelected'),
        addStore: intl.getLabel('account.profile.preferredStore.addStore'),
        error: intl.getFormattedLabel('account.profile.preferredStore.error'),
        modalTitle: intl.getLabel('checkout.component.storeListTopContent.title'),
        modalDescription: intl.getLabel('checkout.component.storeListTopContent.description')
    };
    return /*#__PURE__*/ React.createElement(PreferredStore, {
        globalStoreId: preferredStoreData === null || preferredStoreData === void 0 ? void 0 : preferredStoreData.globalStoreId,
        labels: preferredStoreLabels,
        errorElement: errorElement,
        isModalOpen: isModalOpen,
        onOpenModal: onOpenModal,
        onCloseModal: onCloseModal,
        onStoreSelect: onStoreSelect
    });
};

export { PreferredStoreContainer as default };
//# sourceMappingURL=PreferredStoreContainer.js.map
